import { createContext, ReactNode, useContext, useState } from 'react';

export interface ControlContextInterface {
	selectedState: string | null;
	setSelectedState: (v: string | null) => void;
	election: string | null;
	setElection: (v: string | null) => void;
	congressTab: string | number | null;
	setCongressTab: (v: string | number | null) => void;
	donorTab: string;
	setDonorTab: (v: string) => void;
	seat: string[];
	setSeat: (v: string[]) => void;
	raceFilter: string[];
	setRaceFilter: (v: string[]) => void;
}

// eslint-disable-next-line react-refresh/only-export-components
export const CONTROL_CONTEXT_DEFAULT: ControlContextInterface = {
	selectedState: 'ma',
	setSelectedState: () => {},
	election: 'state',
	setElection: () => {},
	congressTab: 0,
	setCongressTab: () => {},
	donorTab: '',
	setDonorTab: () => {},
	seat: ['open'],
	setSeat: () => {},
	raceFilter: [],
	setRaceFilter: () => {}
};

const ControlContext = createContext(CONTROL_CONTEXT_DEFAULT);

// eslint-disable-next-line react-refresh/only-export-components
export function useControls() {
	return useContext<ControlContextInterface>(ControlContext);
}

export function ControlProvider({ children }: { children: ReactNode }) {
	const [selectedState, setSelectedState] = useState<string | null>(
		CONTROL_CONTEXT_DEFAULT.selectedState
	);
	const [election, setElection] = useState<string | null>(
		CONTROL_CONTEXT_DEFAULT.election
	);
	const [congressTab, setCongressTab] = useState<string | number | null>(
		CONTROL_CONTEXT_DEFAULT.congressTab
	);
	const [donorTab, setDonorTab] = useState<string>(
		CONTROL_CONTEXT_DEFAULT.donorTab
	);
	const [seat, setSeat] = useState<string[]>(CONTROL_CONTEXT_DEFAULT.seat);
	const [raceFilter, setRaceFilter] = useState<string[]>(
		CONTROL_CONTEXT_DEFAULT.raceFilter
	);

	return (
		<ControlContext.Provider
			value={{
				selectedState,
				setSelectedState,
				election,
				setElection,
				congressTab,
				setCongressTab,
				donorTab,
				setDonorTab,
				seat,
				setSeat,
				raceFilter,
				setRaceFilter
			}}
		>
			{children}
		</ControlContext.Provider>
	);
}
